import { render, staticRenderFns } from "./detailContract.vue?vue&type=template&id=7270933e&scoped=true&"
import script from "./detailContract.vue?vue&type=script&lang=js&"
export * from "./detailContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270933e",
  null
  
)

export default component.exports